import "yup-phone-lite";
import * as yup from 'yup';
import DirectDebitFormModel from "./directDebitFormModel";
import * as ibantools from 'ibantools';

const {
  formField: {
    FirstName,
    Surname,
    BIC,
    IBAN,
    TypeOfDirectDebit,
    PaymentFrequency,
    Declaration
  }
} = DirectDebitFormModel;

const paymentFrequencyValidationSchema = yup.string()
  .when([TypeOfDirectDebit.name],
    ([typeOfDirectDebit], schema) => {
      return schema.test(`${PaymentFrequency.name}`,
        `${PaymentFrequency.requiredErrorMsg}`,
        function (paymentFrequency) {
          if (typeOfDirectDebit !== "" && paymentFrequency === "") {
            return false;
          }
          return true;
        });
    });

export const MembershipDirectDebitValidationSchemas = yup.object().shape({
  [FirstName.name]: yup.string().required(`${FirstName.requiredErrorMsg}`)
    .max(FirstName.maxStringCount, `${FirstName.maxStringCountErrorMsg}`),
  [Surname.name]: yup.string().required(`${Surname.requiredErrorMsg}`)
    .max(Surname.maxStringCount, `${Surname.maxStringCountErrorMsg}`),
  [BIC.name]: yup.string().max(BIC.maxStringCount, BIC.maxStringCountErrorMsg).test('validateBic',
    `${BIC.incorrectBicErrorMsg}`,
    function (item) {

      if (item === "") return true;

      return item !== undefined && ibantools.isValidBIC(item);
    }
  ),
  [IBAN.name]: yup.string().required(`${IBAN.requiredErrorMsg}`)
    .max(IBAN.maxStringCount, IBAN.maxStringCountErrorMsg).test(
    'validateIbanNumber',
    `${IBAN.incorrectIbanErrorMsg}`,
    function (item) {
      return ibantools.validateIBAN(item).valid;
    }
  ),
  [Declaration.name]: yup.array().min(1, Declaration.requiredErrorMsg).of(yup.string()
    .required(Declaration.requiredErrorMsg)).required()
});

export const DonationDirectDebitValidationSchemas = yup.object().shape({
  [TypeOfDirectDebit.name]: yup.string().required(`${TypeOfDirectDebit.requiredErrorMsg}`),
  [PaymentFrequency.name]: paymentFrequencyValidationSchema
}).concat(MembershipDirectDebitValidationSchemas);
